// action
import { apiError, loginSuccess } from "./reducer";
import { apiClient } from '../../../helpers/api_helper';
import { profileSuccess } from "../Profile/reducer";
import { co } from "@fullcalendar/core/internal-common";

export const loginUser: any =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;
      response = await apiClient.post(`/accounts/api/login/`,{
          username: user.username,
          password: user.password,
        }
      );
      const data:any = await response;

      if (data.token) {
        localStorage.setItem("authUser", JSON.stringify(data));
          localStorage.setItem("token", data.token);
          dispatch(profileSuccess(data));
          dispatch(loginSuccess(data));
          history("/control-panel");       
      } else{
        dispatch(apiError("Login failed. Please check your credentials and try again."));
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const logoutUser: any = (history: any) => async (dispatch: any) => {
  try {
    await apiClient.post(`/accounts/api/logout/`,{},);
    localStorage.removeItem("authUser");
    history("/login");
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const sendResetPasswordMail: any =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;
      response = await apiClient.post(`/accounts/api/password_reset/`,{
          email: user.email,
        }
      );
      const data:any = await response;

      if (data.status === "OK") {        
          history("/auth-emailverification-basic");
      } else{
        dispatch(apiError("Falha ao enviar email. Por favor verifique o email introduzido e tente novamente."));
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };


  export const resetForgotenPassword: any =
  (token: any, newPassword: any, history: any) => async (dispatch: any) => {
    try {
      let response;
      response = await apiClient.post(`/accounts/api/password_reset/confirm/`,{
          token: token,
          password: newPassword
        }
      );
      const data:any = await response;

      if (data.status === "OK") {
        history("/auth-thankyou-basic");
      } else{
        dispatch(apiError("Falha ao redefinir a palavra-passe. Por favor tente novamente."));
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };



